<template>
  <div class="task-list">
    <CCardBody>
      <CButton
          color="primary"
          class="mb-3"
          @click="showAddModal = true"
      >
        Add Task
      </CButton>

      <Loading :active="loading"/>

      <CDataTable
          :items="tasks"
          :fields="fields"
          hover
          striped
      >
        <template #worker="{ item }">
          <td>{{ item.is_worker_free }}</td>
        </template>
        <template #defaultRole="{ item }">
          <td>{{ item.default_role ? item.default_role.name : "N/A" }}</td>
        </template>

        <template #defaultUser="{ item }">
          <td>{{ item.default_user ? item.default_user.name : "N/A" }}</td>
        </template>

        <template #time="{ item }">
          <td>{{ item.time || '-' }}</td>
        </template>


        <template #actions="{ item }">
          <td>
            <CButton
                color="warning"
                size="sm"
                @click="editTask(item)"
            >
              Edit
            </CButton>
            <CButton
                color="danger"
                size="sm"
                @click="confirmDelete(item)"
            >
              Delete
            </CButton>
            <CButton
                color="success"
                size="sm"
                @click="duplicateTask(item)"
            >
              Duplicate
            </CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>

    <!-- Task Modal -->
    <CModal
        :show.sync="showTaskModal"
        title="Task"
        size="lg"
    >
      <TaskForm
          :task="selectedTask"
          :workProcessId="workProcessId"
          @submit="handleTaskSubmit"
          @cancel="showTaskModal = false"
      />
      <template #footer>
        <CButton type="submit" color="primary" form="taskForm">Save</CButton>
        <CButton color="secondary" @click="showTaskModal = false; selectedTask = null; ">Cancel</CButton>
      </template>
    </CModal>

    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import TaskForm from './TaskForm'
import Loading from "vue-loading-overlay";

export default {
  name: 'TaskList',

  components: {
    Loading,
    TaskForm
  },

  props: {
    workProcessId: {
      type: [Number, String],
      required: true
    }
  },

  data() {
    return {
      fields: [
        {key: 'name', label: 'Name'},
        {key: 'description', label: 'Description'},
        {key: 'time', label: 'Time'},
        {key: 'worker', label: 'Free?'},
        {key: 'defaultRole', label: 'Role'},
        {key: 'defaultUser', label: 'Default User'},
        {key: 'actions', label: 'Actions'}
      ],
      showTaskModal: false,
      selectedTask: null,
      roles: {
        'licar': 'Licacar',
        'klepar': 'Klepar'
      }
    }
  },

  computed: {
    ...mapState({
      tasks: (state) => state.tasks[state.workProcessId] || [],
      loading: state => state.loading
    })
  },

  methods: {
    ...mapActions([
      'fetchTasks',
      'createTask',
      'updateTask',
      'deleteTask'
    ]),

    editTask(task) {
      this.selectedTask = {...task}
      this.showTaskModal = true
    },

    duplicateTask(task) {
      this.selectedTask = {
        ...task,
        id: null,
        name: `Copy of ${task.name}`
      }
      this.showTaskModal = true
    },

    async confirmDelete(task) {
      if (confirm('Are you sure you want to delete this task?')) {
        try {
          await this.deleteTask({
            workProcessId: this.workProcessId,
            taskId: task.id
          })
          this.$refs.toastr.s('Success', 'Task deleted successfully')
        } catch (error) {
          this.$refs.toastr.e('Error', 'Failed to delete task')
        }
      }
    },

    async handleTaskSubmit(task) {
      try {
        if (task.id) {
          await this.updateTask({
            workProcessId: this.workProcessId,
            taskId: task.id,
            data: task
          })
          this.$refs.toastr.s('Success', 'Task updated successfully')
        } else {
          await this.createTask({
            workProcessId: this.workProcessId,
            task
          })
          this.$refs.toastr.s('Success', 'Task created successfully')
        }
        this.showTaskModal = false
      } catch (error) {
        this.$refs.toastr.e('Error', 'Failed to save task')
      }
    }
  },

  created() {
    this.fetchTasks(this.workProcessId)
  }
}
</script>
